const DEV_OSS_ORIGIN = 'https://quotation-test-sz.oss-cn-shenzhen.aliyuncs.com';
export const LOCAL_SIGNED_MEDIA_PREFIX = '/__cpq-dev-signed-media';

/** 本地验收只转发 DEV 私有桶的已签名 GET；原对象路径和查询串逐字保留。 */
export function localSignedMediaOrigin(value?: string): string | null {
  if (!value) return null;
  if (value !== DEV_OSS_ORIGIN)
    throw new Error('本地签名媒体只允许指定 DEV OSS 域');
  return value;
}

export function signedMediaRequestAllowed(
  url: string,
  method = 'GET',
  allowedExportIds = '',
  mapExportPathOnly = false,
): boolean {
  if (method !== 'GET') return false;
  // URL 会先消掉 dot segments；必须先校验未规范化的原路径。
  const rawPath = url.split(/[?#]/, 1)[0];
  if (/(?:^|\/)\.{1,2}(?:\/|$)|%2f|%5c|%2e|\\/i.test(rawPath)) return false;
  let value: URL;
  try {
    value = new URL(url, DEV_OSS_ORIGIN);
  } catch {
    return false;
  }
  if (value.origin !== DEV_OSS_ORIGIN || value.username || value.password)
    return false;
  const legacy = /^\/local\/legacy\/[a-zA-Z0-9_-]+$/.test(value.pathname);
  const exported =
    /^\/cpq\/export-artifacts\/v1\/1\/(\d+)\/\d+\/[a-zA-Z0-9_-]+$/.exec(
      value.pathname,
    );
  if (
    !legacy &&
    (!exported ||
      (!mapExportPathOnly &&
        !allowedExportIds.split(',').includes(exported[1])))
  )
    return false;
  if (value.pathname.split('/').some((part) => /%2f|%5c|%2e|\\/i.test(part)))
    return false;
  return (
    Boolean(value.searchParams.get('x-oss-signature')?.trim()) ||
    Boolean(value.searchParams.get('Signature')?.trim())
  );
}

export function localSignedMediaUrl(
  url: string,
  development = false,
  configuredOrigin?: string,
  allowedExportIds = '',
): string {
  if (!development) return url;
  const origin = localSignedMediaOrigin(configuredOrigin);
  if (
    !origin ||
    !url.startsWith(`${origin}/`) ||
    // 这里只选择同源读取路径；服务端仍按精确 ID 白名单执行访问检查。
    !signedMediaRequestAllowed(url, 'GET', allowedExportIds, true)
  )
    return url;
  return `${LOCAL_SIGNED_MEDIA_PREFIX}${url.slice(origin.length)}`;
}
